module.exports = __webpack_public_path__ + "static/you-cew-1-mobile-ed07db8ec1fabbf43abd62da96930735.jpg";